import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import { Flex } from "@base-ui/containers";
import { Label } from "@base-ui/text";
import { StyledTextArea } from "./textarea.styles";
import { useInput } from "hooks";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var styledSystemKeys = ["space", "layout", "flexbox"];
var TextArea = function TextArea(props) {
  var id = props.id,
    label = props.label,
    value = props.value,
    _props$isControlled = props.isControlled,
    isControlled = _props$isControlled === void 0 ? true : _props$isControlled,
    onChange = props.onChange,
    className = props.className,
    hideLabel = props.hideLabel,
    inverted = props.inverted,
    placeholder = props.placeholder,
    disabled = props.disabled,
    maxLength = props.maxLength,
    _onKeyPress = props.onKeyPress;
  var _useInput = useInput(value, onChange, isControlled),
    inputString = _useInput.inputString,
    onInput = _useInput.onInput;
  return /*#__PURE__*/_jsxs(Flex.Column, _objectSpread(_objectSpread({}, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [/*#__PURE__*/_jsx(Label, {
      htmlFor: id,
      inverted: inverted,
      hideLabel: hideLabel,
      children: label
    }), /*#__PURE__*/_jsx(StyledTextArea, {
      id: id,
      className: className,
      value: inputString,
      disabled: disabled,
      maxLength: maxLength,
      placeholder: placeholder,
      inverted: inverted,
      onChange: function onChange(e) {
        return onInput(e.target.value);
      },
      onKeyPress: function onKeyPress(e) {
        return _onKeyPress && _onKeyPress(e);
      }
    })]
  }));
};
TextArea.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  hideLabel: PropTypes.bool,
  inverted: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  maxLength: PropTypes.number
};
export default TextArea;